import { DISTRIBUTION, SINGLE_SHIPMENT } from 'modules/shipper-order/Form/constants';
const computeShipmentsForRepeating = (shipments) => {
  return shipments.reduce((acc, { id, url, internal_reference, ...rest }) => {
    acc.push({ ...rest });
    return acc;
  }, []);
};

const extraPricesToRemove = ['CANCELLATION', 'DAY_HOLIDAY', 'MANAGEMENT_FEE'];
const extrasToRemove = ['MODIFIED_PRICE'];

const computeShipperOrderForRepeating = (shipperOrder) => {
  const { shipments, extras, shipper, user, shipper_order_type, extra_prices, id } = shipperOrder;

  return {
    shipper,
    user,
    extras: (extras || []).filter((extra) => !extrasToRemove.includes(extra)),
    shipments: computeShipmentsForRepeating(shipments),
    shipper_order_type: shipper_order_type === SINGLE_SHIPMENT ? DISTRIBUTION : shipper_order_type,
    standstills: [],
    extra_prices: extra_prices.filter((extra) => !extraPricesToRemove.includes(extra.concept)),
    repeated_from: id,
  };
};

export { computeShipperOrderForRepeating };
